var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"is-heart",attrs:{"pill":"","variant":"danger"}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'heart']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }